import { useRoles } from './useRoles';
import { setRoleRegistry } from '../utils/roles.utils';
import type { Role } from '../types/database';

let lastSyncedData: Role[] | undefined;

/**
 * Keeps the module-level role registry (see roles.utils) in sync with the roles
 * query. Mounted once at the authenticated app root. The registry is updated
 * during render — before descendants render in the same pass — and the root
 * re-renders when the query resolves, cascading fresh role metadata to every
 * consumer of the pure getRole*ByKey display helpers.
 */
export function useRoleRegistrySync(): void {
  const { data } = useRoles();
  if (data && data !== lastSyncedData) {
    lastSyncedData = data;
    setRoleRegistry(data);
  }
}
